'use client';

import { useInView } from '@/lib/useInView';

interface CaseStudyDescriptionProps {
  description: string;
  className?: string;
  alignment?: 'left' | 'right' | 'full';
}

export default function CaseStudyDescription({ 
  description, 
  className = "", 
  alignment = "right",
}: CaseStudyDescriptionProps) {
  const { ref } = useInView<HTMLDivElement>();

  let justifyClass = "";
  let pClass = "body-lg max-w-4xl";

  switch (alignment) {
    case 'left':
      justifyClass = "flex justify-start";
      break;
    case 'right':
      justifyClass = "flex justify-end";
      break;
    case 'full':
      justifyClass = "";
      pClass += " w-full max-w-none";
      break;
    default:
      justifyClass = "flex justify-end";
  }

  return (
    <div ref={ref} className={`animate-in-view ${justifyClass} ${className}`}>
      <p className={pClass}>
        {description}
      </p>
    </div>
  );
}
